var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.22266,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#14142D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.22266,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#5F5A81"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0556 27.7227C39.4237 27.7231 39.7778 27.864 40.0455 28.1168C40.3132 28.3695 40.4743 28.7149 40.4959 29.0824C40.5175 29.45 40.3979 29.8119 40.1616 30.0942C39.9253 30.3765 39.5901 30.558 39.2246 30.6014L39.0556 30.6115H30.3889V50.8338H50.6111V42.1671C50.6115 41.7989 50.7525 41.4448 51.0052 41.1771C51.258 40.9094 51.6034 40.7483 51.9709 40.7267C52.3384 40.7052 52.7003 40.8247 52.9826 41.061C53.265 41.2973 53.4464 41.6325 53.4899 41.9981L53.5 42.1671V50.8338C53.5002 51.5626 53.225 52.2646 52.7294 52.799C52.2338 53.3334 51.5546 53.6608 50.8278 53.7154L50.6111 53.7227H30.3889C29.6601 53.7229 28.9581 53.4476 28.4237 52.952C27.8892 52.4565 27.5619 51.7772 27.5072 51.0504L27.5 50.8338V30.6115C27.4998 29.8827 27.775 29.1807 28.2706 28.6463C28.7662 28.1119 29.4454 27.7845 30.1722 27.7299L30.3889 27.7227H39.0556ZM51.6944 27.7227C52.6911 27.7227 53.5 28.5315 53.5 29.5282V34.9449C53.5 35.328 53.3478 35.6954 53.0769 35.9663C52.806 36.2371 52.4386 36.3893 52.0556 36.3893C51.6725 36.3893 51.3051 36.2371 51.0342 35.9663C50.7633 35.6954 50.6111 35.328 50.6111 34.9449V32.654L41.098 42.1671H43.3889C43.772 42.1671 44.1394 42.3193 44.4103 42.5902C44.6812 42.8611 44.8333 43.2285 44.8333 43.6115C44.8333 43.9946 44.6812 44.362 44.4103 44.6329C44.1394 44.9038 43.772 45.056 43.3889 45.056H37.9722C36.9756 45.056 36.1667 44.2471 36.1667 43.2504V37.8338C36.1667 37.4507 36.3188 37.0833 36.5897 36.8124C36.8606 36.5415 37.228 36.3893 37.6111 36.3893C37.9942 36.3893 38.3616 36.5415 38.6325 36.8124C38.9034 37.0833 39.0556 37.4507 39.0556 37.8338V40.1247L48.5687 30.6115H46.2778C45.8947 30.6115 45.5273 30.4594 45.2564 30.1885C44.9855 29.9176 44.8333 29.5502 44.8333 29.1671C44.8333 28.784 44.9855 28.4166 45.2564 28.1457C45.5273 27.8748 45.8947 27.7227 46.2778 27.7227H51.6944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR4);
export default __webpack_public_path__ + "static/media/R4.de1c8388bf917ac3436df43782660acc.svg";
export { ForwardRef as ReactComponent };